import { styled } from "@mui/material/styles";

export const CoachCardContainer = styled("div")(({ theme }) => ({
  border: "2px solid #211F45",
  borderRadius: "12px",
  width: "100%",
  "& .coach-image": {
    width: "100%",
    borderTopRightRadius: "12px",
    borderTopLeftRadius: "12px",
    maxHeight: "269px",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "none",
    },
  },
  "& .logo": {
    maxHeight: "36px",
    marginBottom: "5px",
  },
  "& .coach-card-content": {
    padding: "24px",
    "& .title": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "15px",
      flexWrap: "wrap",
      gap: "5px",
      "& h2": {
        margin: "0",
        color: "#01ECFF",
        fontSize: "24px",
      },
      "& span": {
        borderRadius: "9999px",
        border: "0.5px solid rgba(1, 236, 255, 0.75)",
        background: "rgba(1, 236, 255, 0.20)",
        fontSize: "12px",
        padding: "2px 8px",
        display: "flex",
        alignItems: "center",
        gap: "5px",
      },
    },
    "& p": {
      margin: "0 0 15px 0",
      fontSize: "14px",
      color: "#EAEAEA",
    },
    "& ul": {
      display: "flex",
      margin: "0",
      padding: "0 0 0px 0",
      listStyle: "none",
      // borderBottom: "#211F45 1px solid",
      flexWrap: "wrap",
      gap: "10px",
      "& li": {
        background: "#211F45",
        padding: "3px 9px",
        color: "#eaeaea",
        fontSize: "12px",
        borderRadius: "4px",
      },
    },
  },
  "& .coach-card-footer": {
    padding: "24px",
    background: "#211F45",
    borderBottomRightRadius: "12px",
    borderBottomLeftRadius: "12px",
    "& button": {
      background: "transparent",
      fontFamily: "inherit",
      border: "#962EFF 1px solid",
      borderRadius: "8px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "5px",
      fontWeight: "600",
      fontSize: "14px",
      padding: "8px 12px",
      color: "#FEFEFE",
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover, &:disabled": {
        background: "#962EFF",
      },
      "&:disabled": {
        opacity: ".4",
      },
    },
  },
}));
